import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { PathwayService } from '@cpd-app/core-module/services';

import { getPathway, getPathwaySuccess } from './pathway.actions';
import { ErrorReceived } from '../error/error.actions';

@Injectable()
export class PathwayEffects {
  constructor(
    private actions$: Actions,
    private pathwayService: PathwayService
  ) {}

  public getPathway$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getPathway),
      switchMap(({ pathwayId }) => {
        return this.pathwayService.getPathway(pathwayId).pipe(
          map((pathway) => {
            return getPathwaySuccess({ pathway });
          }),
          catchError((error: TypeError) => of(ErrorReceived({ error })))
        );
      })
    )
  );
}
